import { Icon, LinkButton } from '@/components/ui';
import { paths } from '@/routes/paths';

/**
 * A public page whose subject is not there: a company page or a listing that
 * was removed, closed or never existed. It is a normal outcome, not a failure,
 * so it reads as a calm dead end with a way on rather than as an error box.
 *
 * Deliberately says nothing about *why* -- a blocked company, a closed one and
 * a mistyped link all look the same, so the page cannot be used to learn an
 * account's state.
 */
export function Unavailable({ icon = 'search', title, message }) {
  return (
    <section className="app-container py-16 sm:py-24">
      <div className="mx-auto flex max-w-md flex-col items-center text-center">
        <span
          aria-hidden="true"
          className="bg-brand-50 text-brand-600 ring-brand-100 grid size-14 place-items-center rounded-2xl ring-1 ring-inset"
        >
          <Icon name={icon} size={26} />
        </span>
        <h1 className="text-title text-ink mt-5 font-semibold">{title}</h1>
        <p className="text-ink-muted mt-2 text-sm leading-relaxed">{message}</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <LinkButton to={paths.internships}>
            <Icon name="search" size={16} />
            Browse internships
          </LinkButton>
          <LinkButton to={paths.home} variant="secondary">
            Back to home
          </LinkButton>
        </div>
      </div>
    </section>
  );
}
